module.exports = __webpack_public_path__ + "static/media/Home.2576265c.png";